var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full"},[_c(_vm.activeAreaAffectedMod,{tag:"component",attrs:{"areas":_vm.areas,"editObj":_vm.editObj,"affectedAreaKeys":_vm.affectedAreaKeys}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }